import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import { InputGlobal } from "../InputGlobal";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  validatePassword,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
  simplyClick,
} from "../../helpers";
import { landingId, errorEventsPassword } from "../../constants";
import { apiRegistration } from "../../services/api";
import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";
import { useAppendLandingId } from "../../hooks/useAppendLandingId";
import "./Password.scss";
import cn from "classnames";
export const Password = ({ data, setData, nextStep }) => {
  const [errorPassword, setErrorPassword] = useState(null);
  const [passwordShow, setPasswordShow] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [checkBox, setCheckBox] = useState(false);
  const [termsError, setTermsError] = useState(null);
  const [loader, setLoader] = useState(false);

  useAppendLandingId(landingId);

  const handlerSubmit = (e) => {
    e.preventDefault();
    setResponseError(null);

    const resultPassword = validatePassword(data.password);
    let hasError = false;

    if (!resultPassword.status) {
      setErrorPassword(resultPassword.error.text);
      if (errorEventsPassword[resultPassword.error.type]) {
        simplyClick(errorEventsPassword[resultPassword.error.type]);
      }
      hasError = true;
    } else {
      setErrorPassword(null);
    }

    if (!checkBox) {
      setTermsError(
        "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Consent Policy"
      );
      simplyClick("err_lnd_checkbox_nocheckbox");
      hasError = true;
    } else {
      setTermsError(null);
    }

    if (hasError) return;
    simplyClick("cl_lnd_st5_join");
    setLoader(true);
    apiRegistration(prepareRegistrationData(data), responseCb);
  };

  const toggleBtn = (e) => {
    e.preventDefault();
    setPasswordShow(!passwordShow);
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);

        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed == REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }
      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);

      if (data.errors && data.errors.length > 0) {
        let errorText = "";
        for (let i = 0; i < data.errors.length; i++) {
          const error = data.errors[i];
          errorText += i > 0 ? " " + error.message : error.message;
        }
        setResponseError(errorText);
        return;
      }
    }

    setResponseError(
      "Can't register your profile now. Please try again later."
    );
  };

  const handlerAddPassword = (e) => {
    e.preventDefault();
    setErrorPassword(null);
    setData({ ...data, password: e.target.value });
  };

  const handleCheckBox = () => {
    simplyClick("cl_lnd_st5_checkbox_mark");
    setCheckBox(!checkBox);
    setTermsError(null);
  };

  return (
    <>
      {loader && (
        <div className="spin-loader">
          <span>Loading...</span>
        </div>
      )}
      <form className="form__password" onSubmit={handlerSubmit}>
        <h1 className="global__title global__title-mobile">
          Create a strong password
        </h1>
        <div className="input__password-wrapper">
          <InputGlobal
            placeholder={"Enter your password"}
            name={"password"}
            type={passwordShow ? "text" : "password"}
            className={cn("input__global", { error: errorPassword })}
            onChange={handlerAddPassword}
            value={data.password || ""}
            onFocus={() => simplyClick("cl_lnd_st5_type_password")}
          />
          <button onClick={toggleBtn} className="logo__eye">
            {passwordShow ? (
              <img src={Eye} alt="icon" />
            ) : (
              <img src={EyeOff} alt="icon" />
            )}
          </button>
        </div>
        {errorPassword && <p className="error-text">{errorPassword}</p>}
        <div className={"form-group" + (termsError ? " error" : "")}>
          <input
            checked={checkBox}
            onChange={handleCheckBox}
            type="checkbox"
            id="remember_me"
            className="checkBox"
            name="remember"
            value="1"
          />
          <label htmlFor="remember_me">
            <span> I have read and understood, and I agree with the </span>
            <span>
              <a href="/terms-of-use/" target="_blank">
                Terms of Use
              </a>
            </span>
            ,&nbsp;
            <span>
              <a href="/privacy-policy/" target="_blank">
                Privacy Policy
              </a>
            </span>
            , &nbsp;
            <span>
              <a href="/cookie-policy/" target="_blank">
                Cookie Policy

              </a>
            </span>
            ,&nbsp;
            <span>
              <a href="/billing-policy/" target="_blank">
                Billing
              </a>
            </span>
            &nbsp;&&nbsp;
            <span>
              <a href="/refund-policy/" target="_blank">
                Refund Policy
              </a>
            </span>
            ,&nbsp;
            <span>
              <a href="/consent-policy/" target="_blank">
                Consent Policy
              </a>
            </span>
          </label>
        </div>
        {termsError && <p className="error-terms">{termsError}</p>}
        {responseError && <p className="error-text">{responseError}</p>}

        <ButtonSubmit text={"Join now"} />
        <div className="slider__box">
          <span className="step active"></span>
          <span className="step active"></span>
          <span className="step active"></span>
          <span className="step active"></span>
          <span className="step active"></span>
        </div>
      </form>
    </>
  );
};
